import { jsx, Fragment } from "react/jsx-runtime";
import { useLocation, Navigate } from "react-router-dom";
import { getBaseLang, getPrimaryLang } from "@nxplatform/helpers/helpers-pure";
const BaseLangRedirect = ({ children }) => {
  const location = useLocation();
  const baseLang = getBaseLang();
  const primaryLanguage = getPrimaryLang();
  const basePath = baseLang === primaryLanguage ? "" : `/${baseLang}`;
  if (baseLang === primaryLanguage) {
    const [, languagePart] = location.pathname.split("/");
    if (languagePart === baseLang) {
      let redirectPath = `${location.pathname.replace(`/${baseLang}`, "")}`;
      redirectPath = redirectPath === "" ? "/" : redirectPath;
      return /* @__PURE__ */ jsx(Navigate, { to: `${redirectPath}${location.search}`, replace: true });
    }
  }
  if (!location.pathname.startsWith(basePath)) {
    return /* @__PURE__ */ jsx(Navigate, { to: `${basePath}${location.pathname}${location.search}`, replace: true });
  }
  return /* @__PURE__ */ jsx(Fragment, { children });
};
export {
  BaseLangRedirect
};
